import { FC, useMemo } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PIC } from "@ryde/assets";
import { useReportId } from "@ryde/redux";
import {
  reportsTableColumnSortingSF,
  reportsTableColumnsSortingAF,
  SortingEnum,
} from "@ryde/shared";

import { IHeaderPopover } from "./header.popover";
import { HeaderPopoverWrapperStyled } from "./header.popover.styled";

export const HeaderPopoverReports: FC<IHeaderPopover> = ({
  fieldNameResolved,
  sortingDisabled,
  groupingDisabled,
  children,
}) => {
  const { reportId } = useReportId();
  const setColumnSorting = useSetRecoilState(
    reportsTableColumnsSortingAF(reportId),
  );

  const sorting = useRecoilValue(
    reportsTableColumnSortingSF([reportId, fieldNameResolved]),
  );
  const sortByClick = useEvent((): void => {
    setColumnSorting?.([
      { id: fieldNameResolved, desc: sorting === SortingEnum.Asc },
    ]);
  });

  const popoverButtonsDisabled = useMemo(() => {
    return Boolean(groupingDisabled && sortingDisabled);
  }, [groupingDisabled, sortingDisabled]);

  return (
    <HeaderPopoverWrapperStyled>
      {Boolean(children) && (
        <div className="header_text truncate-text">{children}</div>
      )}

      {!popoverButtonsDisabled && (
        <div className="controls_wrapper">
          {!sortingDisabled && sorting === SortingEnum.NotSorted && (
            <PIC.TableSortInitialSVG
              data-e2e="svg-no-sort-popover"
              onClick={sortByClick}
            />
          )}
          {sorting === SortingEnum.Asc && (
            <PIC.TableSortAscSVG
              data-e2e="svg-sort-asc-popover"
              onClick={sortByClick}
            />
          )}
          {sorting === SortingEnum.Desc && (
            <PIC.TableSortDescSVG
              data-e2e="svg-desc-popover"
              onClick={sortByClick}
            />
          )}
        </div>
      )}
    </HeaderPopoverWrapperStyled>
  );
};
